import { render, staticRenderFns } from "./SetAsDefaultDescriptionConfirmationModal.vue?vue&type=template&id=6e82da34&scoped=true&"
import script from "./SetAsDefaultDescriptionConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./SetAsDefaultDescriptionConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SetAsDefaultDescriptionConfirmationModal.vue?vue&type=style&index=0&id=6e82da34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e82da34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e82da34')) {
      api.createRecord('6e82da34', component.options)
    } else {
      api.reload('6e82da34', component.options)
    }
    module.hot.accept("./SetAsDefaultDescriptionConfirmationModal.vue?vue&type=template&id=6e82da34&scoped=true&", function () {
      api.rerender('6e82da34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SetAsDefaultDescriptionConfirmationModal.vue"
export default component.exports